<button
  type="button"
  class="password-toggle"
  aria-label="Show password"
  [attr.aria-pressed]="visible"
  (click)="toggle()"
>
  <fa-icon [icon]="['far', visible ? 'eye-slash' : 'eye']"></fa-icon>
</button>
